import React, { ChangeEvent, useState } from "react";
import { Installation, Device, Organization } from "../common/ObjectTypes";
import TextInput from "../common/TextInput";
import SelectInput from "../common/SelectInput";
import { getCurrentUser } from "../../helpers/authHeader";

type AddEditDeviceTypes = {
  device: Device;
  installations: Installation[];
  organizations: Organization[];
  errors: any;
  addDevice: boolean;
  existingDevice: boolean;
  onChangeSingleSelect: Function;
  onChange: Function;
  onSave: (event: React.FormEvent<HTMLFormElement>) => void;
  onSelectDevice: Function;
  onCancelEdit: Function;
  onDelete: Function;
};

const AddEditDevice = ({
  device,
  installations,
  organizations,
  errors,
  onChange,
  onSave,
  onCancelEdit,
  onChangeSingleSelect,
  onDelete,
  existingDevice,
}: AddEditDeviceTypes) => {
  const currentUser = getCurrentUser();
  const hasOrganizationId = device.organizationId
    ? device.organizationId
    : true;

  const isDisabled =
    !existingDevice && (!currentUser.isSystemAdmin || !hasOrganizationId);

  const getInstallationById = (id: any) => {
    return installations.find((install) => install.installationId === id);
  };
  const defaultInstallation = getInstallationById(device.installationId);

  const getOrganizationById = (id: any) => {
    return organizations.find((org) => org.organizationId === id);
  };
  const defaultOrganization = getOrganizationById(device.organizationId);

  return (
    <div className="w-full my-4">
      <form className="flex flex-col items-center" onSubmit={(e) => onSave(e)}>
        <h1 className="font-bold text-center text-4xl mb-6">
          {existingDevice ? "Device Details" : "Add Device"}
        </h1>
        <div className="bg-grayScale-300 w-2/3">
          {errors.onSave && (
            <div
              className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"
              role="alert"
            >
              <span className="block sm:inline">{errors.onSave}</span>
            </div>
          )}
          <div className="flex flex-col py-2">
            <div className="px-6">
              {/* name */}
              <div className="pb-2">
                <TextInput
                  name={"name"}
                  label={"Name"}
                  placeholder={""}
                  value={device.name}
                  error={errors.name}
                  disabled={isDisabled}
                  className={"bg-white-800 p-2 w-full rounded shadow"}
                  type={"text"}
                  initialFocus={true}
                  onChange={(e: any) => onChange(e)}
                />
                <TextInput
                  name={""}
                  label={"WildXR Number"}
                  placeholder={""}
                  value={device.wildXRNumber || ""}
                  error={errors.wildXRNumber}
                  disabled={true}
                  className={"bg-white-800 p-2 w-full rounded shadow"}
                  type={"text"}
                  initialFocus={true}
                  onChange={(e: any) => onChange(e)}
                />
                <SelectInput
                  name="installationId"
                  label="Select Installation"
                  options={installations.map((install: any) => ({
                    value: install.installationId,
                    label: install.name,
                  }))}
                  onChange={(e: any) =>
                    onChangeSingleSelect("installationId", e)
                  }
                  className="w-full"
                  defaultValue={
                    defaultInstallation
                      ? {
                          value: defaultInstallation.installationId,
                          label: defaultInstallation.name,
                        }
                      : undefined
                  }
                  isDisabled={isDisabled}
                  isLoading={false}
                  isClearable={true}
                  isSearchable={true}
                  isMulti={false}
                  errors={errors.installationId}
                />

                {currentUser.isSystemAdmin ||
                currentUser.organizations.length > 1 ? (
                  <div className="flex flex-col mb-2 ">
                    <SelectInput
                      name="organizationId"
                      label="Select Organization"
                      options={organizations.map((org: any) => ({
                        value: org.organizationId,
                        label: org.name,
                      }))}
                      onChange={(e: any) =>
                        onChangeSingleSelect("organizationId", e)
                      }
                      className="w-full"
                      defaultValue={
                        defaultOrganization
                          ? {
                              value: defaultOrganization.organizationId,
                              label: defaultOrganization.name,
                            }
                          : undefined
                      }
                      isDisabled={isDisabled}
                      isLoading={false}
                      isClearable={true}
                      isSearchable={true}
                      isMulti={false}
                      errors={errors.installationId}
                    />
                  </div>
                ) : (
                  <>
                    {currentUser.organizations.map((org: any) => {
                      return (
                        <div className="py-2" key={org.organizationId}>
                          <span>Organization: </span>
                          {org.name}
                        </div>
                      );
                    })}
                  </>
                )}
                <div className="py-2 flex flex-row justify-end">
                  <button
                    className="px-3 py-2 rounded bg-deepGreen-500 text-white hover:bg-deepGreen-700 drop-shadow-lg"
                    onClick={() => onCancelEdit()}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit" // Change to submit type to handle form submission
                    className="px-3 py-2 ml-2 rounded bg-deepGreen-500 text-white hover:bg-deepGreen-700 drop-shadow-lg"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddEditDevice;
